import { TextBase } from '@carboncopyco/ui';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export const EmptyState = ({ title, description, action }: EmptyStateProps) => {
  return (
    <div className="flex flex-col gap-2 items-center justify-center h-64">
      <TextBase
        label={title}
        color="text-ds-natural-600"
      />
      {description && (
        <TextBase
          label={description}
          color="text-ds-natural-400"
        />
      )}
      {action && <div className="mt-2.5">{action}</div>}
    </div>
  );
};
